import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (isStandalone) return;
    if (localStorage.getItem("plyx_install_dismissed")) return;

    if (window.__plyxInstallPrompt) {
      setDeferred(window.__plyxInstallPrompt);
      setShow(true);
    }
    const onInstallable = () => {
      setDeferred(window.__plyxInstallPrompt);
      setShow(true);
    };
    window.addEventListener("plyx-installable", onInstallable);
    return () => window.removeEventListener("plyx-installable", onInstallable);
  }, []);

  const install = async () => {
    const p = deferred || window.__plyxInstallPrompt;
    if (!p) return;
    p.prompt();
    await p.userChoice;
    window.__plyxInstallPrompt = null;
    setDeferred(null);
    setShow(false);
  };

  const dismiss = () => {
    localStorage.setItem("plyx_install_dismissed", "1");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="install-prompt"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[70] w-[calc(100%-2rem)] max-w-md bg-card border border-primary/50 glow-green p-4 flex items-center gap-4 animate-fade-up"
    >
      <div className="w-10 h-10 shrink-0 flex items-center justify-center border border-primary/40 bg-primary/10">
        <Download size={20} strokeWidth={1.5} className="text-primary" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-mono font-bold text-sm">Install Plyx Cyber Guard</div>
        <div className="text-xs text-muted-foreground">Add it to your device for one-tap access.</div>
      </div>
      <button
        data-testid="install-app-button"
        onClick={install}
        className="rounded-none font-mono text-xs uppercase tracking-widest bg-primary text-primary-foreground px-3 py-2 hover:bg-primary/90 transition-colors"
      >
        Install
      </button>
      <button data-testid="install-dismiss" onClick={dismiss} className="text-muted-foreground hover:text-foreground transition-colors">
        <X size={16} strokeWidth={1.5} />
      </button>
    </div>
  );
}
